import React from 'react'
import { AppRoutes } from '../types/constants.types';
import UsersPageStandardized from '../pages/Users/UsersPageStandardized';
import Dashboard from '../pages/Dashboard/Dashboard';
import LogoutPage from '../pages/Auth/LogoutPage';
import CampaignPageStandardized from '../pages/Campaigns/CampaignPageStandardized';
import CampaignDetails from '../pages/Campaigns/CampaignDetails';
import DonationPageStandardized from '../pages/Donations/DonationPageStandardized';
import ReferralPerformancePage from '../pages/Referrals/ReferralPerformancePage';
import ShipmentsPageStandardized from '../pages/Shipments/ShipmentsPageStandardized';
import KioskManagementPage from '../pages/Kiosks/KioskManagementPage';
import KioskConfigurationPage from '../pages/KioskConfiguration/KioskConfigurationPage';
import KioskPerformancePage from '../pages/KioskPerformance/KioskPerformancePage';
import OwnerReportingPayoutSettingsPage from '../pages/OwnerReportingPayoutSettings/OwnerReportingPayoutSettingsPage';
import OwnerRewardsPage from '../pages/OwnerRewards/OwnerRewardsPage';
import SocialMediaCampaignPage from '../pages/SocialMediaCampaign/SocialMediaCampaignPage';
import KioskBillingPage from '../pages/KioskBilling/KioskBillingPage';
import OwnerPayoutRequestsPage from '../pages/OwnerPayoutRequests/OwnerPayoutRequestsPage';
import PromotionsPage from '../pages/Promotions/PromotionsPage';
import CmsPage from '../pages/Cms/CmsPage';
import SupportRequestsPage from '../pages/SupportRequests/SupportRequestsPage';
import FundsPageStandardized from '../pages/Funds/FundsPageStandardized';
import SiteRequestsPage from '../pages/SiteRequests/SiteRequestsPage';
import KioskRegistrationsPage from '../pages/KioskRegistrations/KioskRegistrationsPage';
import WaitlistQrManagementPage from '../pages/SiteRequests/WaitlistQrManagementPage';
import { AdminRole } from '../types/constants.types';

type route = {
    path: string;
    component: JSX.Element;
    auth?: Boolean | undefined | null;
    children?: route[];
    allowedRoles?: string[];
}

export const routes: route[] = [
    { path: AppRoutes.DASHBOARD, component: <Dashboard />, allowedRoles: [AdminRole.ADMIN] },
    {
        path: AppRoutes.CAMPAIGN,
        component: <CampaignPageStandardized />,
        auth: true,
        allowedRoles: [AdminRole.ADMIN],
        children: [
            {
                path: ":id",
                component: <CampaignDetails />,
                auth: true,
                allowedRoles: [AdminRole.ADMIN],
            },
        ],
    },
    { path: AppRoutes.DONATIONS, component: <DonationPageStandardized />, allowedRoles: [AdminRole.ADMIN] },
    { path: AppRoutes.FUNDS, component: <FundsPageStandardized />, allowedRoles: [AdminRole.ADMIN, AdminRole.T2F_MANAGER] },
    { path: AppRoutes.REFERRALS, component: <ReferralPerformancePage />, allowedRoles: [AdminRole.ADMIN] },
    { path: AppRoutes.USERS, component: <UsersPageStandardized />, allowedRoles: [AdminRole.ADMIN] },
    { path: AppRoutes.LOGOUT, component: <LogoutPage />, allowedRoles: [AdminRole.ADMIN, AdminRole.T2F_MANAGER, AdminRole.KIOSK_OWNER] },
    { path: AppRoutes.SHIPMENTS, component: <ShipmentsPageStandardized />, allowedRoles: [AdminRole.ADMIN] },
    { path: AppRoutes.KIOSKS, component: <KioskManagementPage />, allowedRoles: [AdminRole.ADMIN, AdminRole.T2F_MANAGER, AdminRole.KIOSK_OWNER] },
    { path: AppRoutes.KIOSK_BILLING, component: <KioskBillingPage />, allowedRoles: [AdminRole.ADMIN, AdminRole.T2F_MANAGER] },
    { path: AppRoutes.OWNER_PAYOUT_REQUESTS, component: <OwnerPayoutRequestsPage />, allowedRoles: [AdminRole.ADMIN, AdminRole.T2F_MANAGER] },
    { path: AppRoutes.KIOSK_CONFIGURATION, component: <KioskConfigurationPage />, allowedRoles: [AdminRole.ADMIN, AdminRole.T2F_MANAGER, AdminRole.KIOSK_OWNER] },
    { path: AppRoutes.KIOSK_PERFORMANCE, component: <KioskPerformancePage />, allowedRoles: [AdminRole.ADMIN, AdminRole.T2F_MANAGER, AdminRole.KIOSK_OWNER] },
    { path: AppRoutes.OWNER_REPORTING_PAYOUT_SETTINGS, component: <OwnerReportingPayoutSettingsPage />, allowedRoles: [AdminRole.KIOSK_OWNER] },
    { path: AppRoutes.OWNER_REWARDS, component: <OwnerRewardsPage />, allowedRoles: [AdminRole.KIOSK_OWNER] },
    { path: AppRoutes.SOCIAL_MEDIA_CAMPAIGN, component: <SocialMediaCampaignPage />, allowedRoles: [AdminRole.ADMIN, AdminRole.T2F_MANAGER, AdminRole.KIOSK_OWNER] },
    { path: AppRoutes.SUPPORT_REQUESTS, component: <SupportRequestsPage />, allowedRoles: [AdminRole.ADMIN, AdminRole.T2F_MANAGER, AdminRole.KIOSK_OWNER] },
    { path: AppRoutes.SITE_REQUESTS, component: <SiteRequestsPage />, allowedRoles: [AdminRole.ADMIN, AdminRole.T2F_MANAGER] },
    { path: AppRoutes.KIOSK_REGISTRATIONS, component: <KioskRegistrationsPage />, allowedRoles: [AdminRole.ADMIN, AdminRole.T2F_MANAGER] },
    { path: AppRoutes.WAITLIST_QR_MANAGEMENT, component: <WaitlistQrManagementPage />, allowedRoles: [AdminRole.ADMIN] },
    { path: AppRoutes.PROMOTIONS, component: <PromotionsPage />, allowedRoles: [AdminRole.ADMIN] },
    { path: AppRoutes.CMS, component: <CmsPage />, allowedRoles: [AdminRole.ADMIN, AdminRole.T2F_MANAGER] },
];
